import {
  FcIdea,
  FcAssistant,
  FcCollaboration,
  FcComments,
  FcSportsMode,
  FcBullish,
} from 'react-icons/fc';
export const FEATURES = [
  {
    id: 1,
    title: 'Personalized Guidance',
    icon: FcCollaboration,
    text: 'Ivy adapts to each student’s level and learning style, offering real-time support every step of the way.',
  },
  {
    id: 2,
    title: 'Dynamic Writing Prompts',
    icon: FcIdea,
    text: 'From persuasive essays to creative stories, Ivy generates prompts tailored to your child’s progress and interests.',
  },
  {
    id: 3,
    title: 'Step-by-Step Support',
    icon: FcAssistant,
    text: 'Whether brainstorming ideas, organizing outlines, or revising drafts, Ivy provides explicit instruction to simplify the writing process.',
  },
  {
    id: 4,
    title: 'Engaging Writing Games',
    icon: FcSportsMode,
    text: 'Make writing exciting with story-building games that foster creativity and collaboration.',
  },
  {
    id: 5,
    title: 'Actionable Feedback',
    icon: FcComments,
    text: 'Ivy gives constructive, real-time comments to refine skills and improve every draft.',
  },
  {
    id: 6,
    title: 'Celebrate Growth',
    icon: FcBullish,
    text: 'With detailed progress insights, Ivy ensures students and parents stay informed and motivated.',
  },
];
